import { META_PIXEL_BASIC_PROPERTIES } from '@repo/common-utils';
import { useMutation, UseMutationConfig } from 'react-relay';

import { searchRefundV2Mutation } from '@/__generated__/searchRefundV2Mutation.graphql';
import { searchRefundV2 } from '@/graphql/mutation/taxRefund/searchRefundV2';

const useSearchRefund = () => {
  const [commit, isInFlight] = useMutation<searchRefundV2Mutation>(searchRefundV2);

  const handleSearchRefund = (mutationConfig: UseMutationConfig<searchRefundV2Mutation>) => {
    const metaProperties = sessionStorage.getItem(META_PIXEL_BASIC_PROPERTIES);
    if (metaProperties) {
      mutationConfig.variables = { ...mutationConfig.variables, metaProperties };
    }
    commit(mutationConfig);
  };
  return { commit: handleSearchRefund, isInFlight };
};

export default useSearchRefund;
